export default __webpack_public_path__ + "static/media/arrowUp.e45a37b2.svg";